var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{staticClass:"ap-datepicker",attrs:{"prefix-class":"xmx","type":_vm.dateType,"lang":{
    formatLocale: {
      firstDayOfWeek: 1,
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthsShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      weekdaysMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
    },
    monthBeforeYear: true,
  },"range":_vm.range,"format":_vm.formatType,"show-second":false,"disabled-date":_vm.disabledDate,"title-format":"DD/MM/YYYY","time-title-format":"DD/MM/YYYY","confirm":true,"confirm-text":"CONFIRMAR","show-time-panel":_vm.showTimePanel,"placeholder":_vm.placeholder},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('button',{staticClass:"md-button btn btn-nonenary",on:{"click":_vm.toggleTimePanel}},[_vm._v("\n      "+_vm._s(_vm.showTimePanel ? 'Selecionar data' : 'Selecionar hora e minuto')+"\n    ")])]},proxy:true}]),model:{value:(_vm.dateSelected),callback:function ($$v) {_vm.dateSelected=$$v},expression:"dateSelected"}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }